import axios from 'axios';
import { isEqual } from 'lodash';
import React from 'react';
import ChartComponent from '../../commonComponents/ChartComponent';
import LoadingComponent from '../../commonComponents/LoadingComponent';
import NoDataFound from '../../commonComponents/NoDataFound';
import { DBService } from '../../SummaryComponents/component/IndexedDB';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';

var base64 = require('base-64');
var localParams = {};
var gran = null, questionExplain = null;

class Chart extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...props, i: 0 };
        this._db = new DBService();
    }    
    arePrevAndThisPropsEqual(prevProps, nextProps) {
        if (prevProps.breakUp == nextProps.breakUp && prevProps.category == nextProps.category && prevProps.categoryValue == nextProps.categoryValue && prevProps.metric == nextProps.metric && prevProps.startDate == nextProps.startDate && prevProps.endDate == nextProps.endDate && prevProps.metricRange == nextProps.metricRange && prevProps.analysis == nextProps.analysis && prevProps.chartDispStyle == nextProps.chartDispStyle && prevProps.chartType == nextProps.chartType && prevProps.clusterCount == nextProps.clusterCount && prevProps.drill == nextProps.drill && prevProps.index == nextProps.index && prevProps.initial == nextProps.initial && prevProps.limit == nextProps.limit && prevProps.regressionLine == nextProps.regressionLine && prevProps.sortOrder == nextProps.sortOrder && prevProps.compare == nextProps.compare && prevProps.chartCat == nextProps.chartCat && prevProps.include == nextProps.include && prevProps.exclude == nextProps.exclude && prevProps.globalFilters == nextProps.globalFilters && (prevProps.prevStartDate == nextProps.prevStartDate || prevProps.prevStartDate == nextProps?.allData?.props?.prevStartDate) && (prevProps.prevEndDate == nextProps?.prevEndDate || prevProps.prevEndDate == nextProps?.allData?.props?.prevEndDate) && prevProps?.sortMetric == nextProps?.sortMetric && prevProps?.cagrPoint == nextProps?.cagrPoint) 
            return true;
        else
            return false;
}
    stateSetFromResponse(data, nextProps){
        let that = this
        if (data && data != '5' && data != 'Something went wrong!' && nextProps.selectedMetricDisp.length) {
            // if ((chartCat.indexOf('Scatter') > -1 || chartCat.indexOf('Map') > -1) && nextProps.analysis !== "false" && nextProps.analysis !== false && nextProps.analysis !== 'radius') {
            // var temp_analysis = typeof nextProps.analysis === "boolean" ? nextProps.analysis.toString() : nextProps.analysis;
            // var tempClusterCount = temp_analysis != "false" && temp_analysis && (temp_analysis.indexOf('quadrant') > -1 || temp_analysis.toString() === "true") ? (temp_analysis.indexOf('radius') > -1 ? 4 : nextProps.clusterCount) : 1;
            // clusterInfo(jQuery.parseJSON(data.chart).data.series, nextProps.metric, tempClusterCount, 'chart', temp_analysis);
            // }
            var minMaxData = JSON.parse(data.chart).minMaxData;
            if (minMaxData) {
                var temp = addMinMaxDataToMetricDisp(that.props.selectedMetricDisp, minMaxData[0], nextProps.metricRange);
                that.props && that.props.handleChange ? that.props.handleChange('metricDisp', temp) : '';
            }
            if (data.sum) {
                var summary = JSON.parse(data.sum);
                summary = summary && summary['result'] ? summary['result'][0] : summary;
                if (((nextProps.compare == 'true' || nextProps.compare == true) && nextProps.dataMover == 2) && summary['data']) {
                    summary = summary['data']['result'][0];
                }
                summary = data.flag.showChartSummary ? summary : 0;
            } else summary = null;
            data = JSON.parse(data.chart);
            if (data.explain) {
                questionExplain = data.explain;
                jQuery("#questionExplain").html(questionExplain);
            }
            var compare_dates = null;
            if (data.compared)
                compare_dates = data.compared;
        }
        else if (data == "5")
            data = data; //if data greater than 1000
        else if (!nextProps.selectedMetricDisp.length)  // To handle the case when metric is not available in metricDisp like % share is only available in table not in chart.
            data = -1;
        else data = 0;
        segmentData = data?.data?.series;
        that.setState({
            chart: data,
            metric: nextProps.metric,
            chartCat: nextProps.chartCat,
            category: nextProps.category,
            breakUp: nextProps.breakUp,
            period: nextProps.period,
            summary: summary,
            compare_dates: compare_dates
        })
    }
    componentWillReceiveProps(nextProps) {
        var indexedDB = this._db
        var that = this;
        var date = nextProps.date == 'undefined' || nextProps.date == 'null' ? null : nextProps.date;
        var point = nextProps.point == 'undefined' || nextProps.point == 'null' ? null : nextProps.point;
        var range = !this.state.i || !this.arePrevAndThisPropsEqual(this.props, nextProps);
        var dataMover = this.props.dataMover;
        var compareRank = this.props.compareRank;
        // if (!date && range) {
        if (range) {
            jQuery('.chartsInfo').html('');
            var that = this;
            var chartCat = nextProps.chartCat === 'Treemap' ? 'Bar' : nextProps.chartCat;
            var compare = false;
            var breakup, period, chartType, dummy, metricCheck, dateDiff;
            if (nextProps.breakUp == '1')
                breakup = 1;
            else
                breakup = nextProps.breakUp;
            that.setState({
                chart: null,
                prevStartDate: nextProps?.prevStartDate? nextProps?.prevStartDate:nextProps.allData?.props?.prevStartDate,
                prevEndDate: nextProps?.prevEndDate? nextProps?.prevEndDate:nextProps.allData?.props?.prevEndDate,
                metric: nextProps.metric,
                initial: nextProps.initial,
                drillHandle: nextProps.drillHandle,
                chartCat: nextProps.chartCat,
                getInsightData: nextProps.getInsightData,
                metricText: nextProps.metricText,
                propertyText: nextProps.propertyText,
                breakupText: nextProps.breakupText,
                startDateDisp: nextProps.startDateDisp,
                endDateDisp: nextProps.endDateDisp,
                breakUp: breakup,
                allData: nextProps.allData,
                i: that.state.i + 1,
            });

            const userId = this.props.authData ? this.props.authData.userId : null;
            const authorization_value = "Basic " + base64.encode(userId + ":");

            const dataset_info = JSON.parse(localStorage.Dataset);
            var parameters = {
                siteId: dataset_info.siteId, toolId: nextProps.toolId ? nextProps.toolId : dataset_info.toolId, startDate: nextProps.startDate, endDate: nextProps.endDate, selectedProperty: nextProps.category, breakUp: nextProps.breakUp, includeBreakUp: refineURLData(nextProps.include), excludeBreakUp: nextProps.exclude, selectedMetric: nextProps.metric, period: nextProps.chartType, chart: chartCat, analysis: nextProps.analysis, clusterCount: nextProps.clusterCount, chartDisp: nextProps.chartDisp, gran: gran, sortOrder: nextProps.sortOrder, limit: nextProps.limit, insightType: nextProps.insightType, insightMetric: nextProps.insightMetric, getSummary: false, range: nextProps.metricRange, compare: nextProps.compare, dataMover: dataMover, dashboard: true, compareRank: compareRank, isInsight: nextProps.isInsight, test: true, selectedParam: this.props.selectedParam,sortMetric:nextProps.sortMetric,cagrPoint:nextProps.cagrPoint,removeGlobalFilter:nextProps?.removeGlobalFilter,prevStartDate:nextProps.allData?.props?.prevStartDate,prevEndDate:nextProps?.allData?.props?.prevEndDate,
                ytdcagr: nextProps?.ytdcagr ? nextProps?.ytdcagr : null
            }
            setCacheFlag([]);
            // IndexedDB code
            var idbParams = JSON.parse(JSON.stringify(parameters));
            idbParams['userId'] = userId
            idbParams['globalFilters'] = nextProps.globalFilters
            idbParams['prevStartDate'] = nextProps.allData?.props?.prevStartDate
            idbParams['prevEndDate'] = nextProps?.allData?.props?.prevEndDate

            indexedDB.get("ChartData", JSON.stringify(idbParams)).then(e => {
                if (e) {         
                    let cachedValue = JSON.parse(e.object);
                    var data = that.handleChartData(cachedValue);
                     if (cachedValue.information && cachedValue?.information != "No data Available for the requested parameters") {
                        if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(cachedValue.information.minMaxData)) === true) {
                            delete parameters.metricRange;
                            delete parameters.range;
                            if (isEqual(localParams, parameters) === false) {
                                localParams = parameters
                                minMaxDataGlobal = cachedValue.information.minMaxData;
                            }
                        } else if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(cachedValue.information.minMaxData)) === false) {
                            localParams = parameters
                            minMaxDataGlobal = cachedValue.information.minMaxData;
                        }
                    }
                    setCacheFlag(cachedValue);
                    that.stateSetFromResponse(data, nextProps)
                } else {
                    CallAPI("GET", "/app/trendChart", null, parameters, 0, function (response) {
                        if(is500Error(response)) {
                            that.setState({
                                chart: null,
                                pageError: true,
                                response: response
                            })
                        }
                        else {
                            var data = that.handleChartData(response);
                            let tempParams = { ...parameters }
                             if (response.information && response?.information != "No data Available for the requested parameters") {
                                if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(response.information.minMaxData)) === true) {
                                    delete tempParams.metricRange;
                                    delete tempParams.range;
                                    delete localParams.metricRange;
                                    delete localParams.range;
                                    if (isEqual(localParams, tempParams) === false) {
                                        localParams = tempParams
                                        minMaxDataGlobal = response.information.minMaxData;
                                    }
                                } else if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(response.information.minMaxData)) === false) {
                                    localParams = parameters
                                    minMaxDataGlobal = response.information.minMaxData;
                                }
                            }
                            var resultData = JSON.stringify(response)
                            indexedDB.put("ChartData", resultData, JSON.stringify(idbParams))
                            setCacheFlag(response);
                            that.stateSetFromResponse(data, nextProps)
                        }                        
                    }, this.props.authData)

                    /* Commented below axios api call & changed it to above CallAPI method */
                    // let callAPIParams = {
                    //     headers: { Authorization: authorization_value },
                    //     params: parameters
                    // }
                    // let url = "/app/trendChart"
                    // axios.get(url, callAPIParams).then(response => {
                    //     var data = this.handleChartData(response.data);
                    //     let tempParams = {...parameters}
                    //     if(response.data.information) {
                    //         if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(response.data.information.minMaxData)) === true ) {
                    //             delete tempParams.metricRange;
                    //             delete tempParams.range;
                    //             delete localParams.metricRange;
                    //             delete localParams.range;
                    //             if (isEqual(localParams, tempParams) === false) {
                    //                 localParams = tempParams
                    //                 minMaxDataGlobal = response.data.information.minMaxData;    
                    //             }
                    //         } else if (isEqual(Object.keys(minMaxDataGlobal), Object.keys(response.data.information.minMaxData)) === false ) {
                    //             localParams = parameters
                    //             minMaxDataGlobal = response.data.information.minMaxData;
                    //         }
                    //     }                     
                    //     var resultData = JSON.stringify(response.data)
                    //     indexedDB.put("ChartData", resultData, JSON.stringify(parameters))
                    //     setCacheFlag(response.data);
                    //     that.stateSetFromResponse(data, nextProps)
                    // }).catch(error => {
                    //     if(error.request.status === 408) {
                    //         alert("Session Timed Out. Please login again.");
                    //         logoutHandle(true);
                    //     } else {
                    //         alert(`${error.response.status}: Server Error, please try again later`);
                    //     }  
                    // })
                }
            })
        }
    }
    componentDidCatch(error, info) {
        this.setState({
            pageError: true
        })
    }
    handleChartData(chartData) {
        if (chartData.mapConfigure) {
            chartData.data.mapConfigure = chartData.mapConfigure;
        }
        return { "chart": JSON.stringify(chartData) }
    }
    componentWillMount() {
        // if (this.props.index != 1)
        this.componentWillReceiveProps(this.props);
        // else
        //     this.setState({ chart: null })
    }
    handleClickLine() {
        this
            .props
            .insightHandle(null, null);
    }
    openSetting() {
        if (this.props.index === 1) {
            if (jQuery(window).width() >= mobile_width) {
                openSidebar('FilterDiv', filter_desktop_width);
                document.getElementById('main-content').style.marginRight = main_content_div_filter;
            } else openSidebar('FilterDiv', filter_mobile_width);
            var url = document.location.pathname;
            if (url == '/dashboard/charttype' && highChartsDiv) {
                highChartsDiv.reflow();
            }
        }
    }
    componentDidUpdate() {
        jQuery('[data-toggle="tooltip"]').tooltip();
        if (filter_enabled === "1") {
            this.openSetting();
        }
        filter_enabled = 3;
    }
    getSummaryContent(summaryState, startDateDisp, endDateDisp, description) {
        if (this.props.insightType == "true")
            return null;
        var keys = [];
        var values = [];
        var metricArray = [];
        var i = 0;
        var keyLength = null;
        if (this.props.dataMover == 2 && (this.props.compare == 'true' || this.props.compare == true)) {
            var keys = ['Old data', 'Current data', 'Growth'];
            var values = [summaryState['previous_value'], summaryState['data'], summaryState['growth']];
            var key = this.props.metric;
            metricArray = refineData(key, metricGlobal, metricFunction);
            var k = metricArray['metricUnit'];
            var summary = keys.map(function (val, index) {
                k = val == 'Growth' ? '%' : k;
                var valueToConsider = values[index];
                valueToConsider = valueToConsider ? valueToConsider : 0;
                var number = parseFloat(valueToConsider).toFixed(2);
                var newDataFull = number_shorten(number, metricArray.roundOff, metricArray.numberShorten);
                var mainValue = delimitNumbersIndianFormat(valueToConsider, metricArray.roundOff);
                if (k == 'INR.')
                    newDataFull = <span>&#x20B9; {newDataFull}</span>;
                else if (k != '') {
                    if (k == "%")
                        newDataFull = <span>{newDataFull + " " + k}</span>;
                    else newDataFull = <span>{k + " " + newDataFull}</span>;
                }
                if (!description) {
                    return <div className='col-md-3' style={{ marginTop: '1%', padding: '0%', fontFamily: 'roboto-bold' }} key={index}>
                        <div style={{ fontSize: '24px', display: 'inline-block' }} title={mainValue} data-toggle="tooltip" data-placement="right">{newDataFull}</div>
                        <div>{val}</div>
                    </div>;
                } else {
                    if (index == endMetric - 1 && index != 0)
                        return <span>{" and "}{val}{" is "}{newDataFull}</span>;
                    else if (index)
                        return <span>{", "}{val}{" is "}{newDataFull}</span>;
                    else return <span>{val}{" is "}{newDataFull}</span>;
                }
            });
        } else {
            jQuery.each(summaryState, function (key, value) {
                if (i % 2) {
                    keys.push(value);
                } else {
                    metricArray.push(refineData(key, metricGlobal, metricFunction));
                    values.push(value);
                }
                i++;
            });
            keyLength = keys.length;
            if (keyLength > 1 && this.props.index != 1) {
                return (
                    <div
                        className='col-md-12' style={{ margin: '-12px 0px 10px -30px', fontSize: '15px' }}>
                        <div className='col-md-12' style={{ marginTop: '1%', fontFamily: 'roboto-bold' }}>
                            <div style={{ fontSize: '24px' }} title=''>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                );
            }
            var endMetric = keys.length;
            var summary = keys.map(function (val, index) {
                var k = val.split('(');
                if (k[1]) {
                    val = k[0];
                    k = k[1].split(')');
                    k = k[0];
                    var valueToConsider = values[index];
                    valueToConsider = valueToConsider ? valueToConsider : 0;
                    var number = parseFloat(valueToConsider).toFixed(2);
                    var newDataFull = number_shorten(number, metricArray[index].roundOff, metricArray[index].numberShorten);
                    var mainValue = delimitNumbersIndianFormat(valueToConsider);
                    if (k == 'INR.')
                        newDataFull = <span>&#x20B9; {newDataFull}</span>;
                    else if (k != '') {
                        if (k == "%")
                            newDataFull = <span>{newDataFull + " " + k}</span>;
                        else newDataFull = <span>{k + " " + newDataFull}</span>;
                    }
                    if (!description) {
                        return <div className='col-md-3' style={{ marginTop: '1%', padding: '0%', fontFamily: 'roboto-bold' }} key={index}>
                            <div style={{ fontSize: '24px', display: 'inline-block' }} title={mainValue} data-toggle="tooltip" data-placement="right">{newDataFull}</div>
                            <div>{val}</div>
                        </div>;
                    } else {
                        if (index == endMetric - 1 && index != 0)
                            return <span>{" and "}{val}{" is "}{newDataFull}</span>;
                        else if (index)
                            return <span>{", "}{val}{" is "}{newDataFull}</span>;
                        else return <span>{val}{" is "}{newDataFull}</span>;
                    }
                }
            });
        }
        if (this.props.index == 1) {
            var summaryStyle = { padding: '0px', fontSize: '15px', display: "contents", float: "left", overflow: "auto" };
        } else
            var summaryStyle = { fontSize: '15px' };
        if (!description) {
            return (
                <div style={summaryStyle}>
                    {summary}
                </div>
            );
        } else {
            return summary;
        }
    }
    handleFavoriteMark(e) {
        var id = jQuery(e.target).attr('id');
        var beforeLikeClass = 'fa fa-heart-o';
        var afterLikeClass = 'fa fa-heart';
        var beforeLikeToolTip = 'Mark as favorite';
        var afterLikeToolTip = 'Favorite';
        var givenClass = jQuery(e.target).attr('class');
        givenClass = givenClass.replace(' has-tooltip', '');
        if (givenClass == beforeLikeClass) {
            jQuery(e.target).removeClass(givenClass).addClass(afterLikeClass);
            jQuery(e.target).parent().tooltip('hide').attr('data-original-title', afterLikeToolTip).tooltip('fixTitle').tooltip('show');
        } else {
            jQuery(e.target).removeClass(givenClass).addClass(beforeLikeClass);
            jQuery(e.target).parent().tooltip('hide').attr('data-original-title', beforeLikeToolTip).tooltip('fixTitle').tooltip('show');
        }
    }
    openComment(type, e) {
        var id = jQuery(e.target).parent().parent().attr('id')
        var likeId = '#' + id + 'Like';
        var dislikeId = '#' + id + 'Dislike';
        var likeColor = jQuery(likeId).css('color');
        var dislikeColor = jQuery(dislikeId).css('color');
        if (type === 'like') {
            document.getElementById('hiddenResponse').value = "Like";
            if (likeColor == 'rgb(0, 0, 0)' && dislikeColor == 'rgb(0, 0, 0)')
                jQuery(likeId).css('color', 'red');
            else if (likeColor == 'rgb(255, 0, 0)' && dislikeColor == 'rgb(0, 0, 0)')
                jQuery(likeId).css('color', 'black');
            else if (likeColor == 'rgb(0, 0, 0)' && dislikeColor == 'rgb(255, 0, 0)') {
                jQuery(likeId).css('color', 'red');
                jQuery(dislikeId).css('color', 'black');
            }
        }
        else {
            document.getElementById('hiddenResponse').value = "DisLike";
            if (likeColor == 'rgb(0, 0, 0)' && dislikeColor == 'rgb(0, 0, 0)')
                jQuery(dislikeId).css('color', 'red');
            else if (likeColor == 'rgb(0, 0, 0)' && dislikeColor == 'rgb(255, 0, 0)')
                jQuery(dislikeId).css('color', 'black');
            else if (likeColor == 'rgb(255, 0, 0)' && dislikeColor == 'rgb(0, 0, 0)') {
                jQuery(dislikeId).css('color', 'red');
                jQuery(likeId).css('color', 'black');
            }
        }
    }
    showDescription(e) {
        var id = '#' + jQuery(e.target).attr('id');
        var flag;
        var title = ((jQuery(id).text()).toLowerCase()).split(' ')[0];
        if (title == 'show') {
            title = 'Hide';
            flag = true;
        } else {
            title = 'Show';
            flag = false;
        }
        title += ' Description';
        jQuery(id).text(title);
        this.refs.descriptionRef.showDescription(flag);
    }
    render() {
        var point = this.props.point == 'undefined' || this.props.point == 'null' ? null : this.props.point;
        var mainData = null;
        var topFilterToInsert = null;
        // if(this.props.index>1){
        //     var topFilterToInsert = null;
        // }else var topFilterToInsert = <Topfilters selectedMetricDisp={this.props.selectedMetricDisp} property={this.props.category} allData={this.props.allData} type={"charts"} updateMetricRange={this.props.updateMetricRange}/>;

        if((this.props.pageError || this.state.pageError) && this.state.chart == null) {
            let is500 = this.state.response && this.state.response['error_code'] == 500 ? true : false
            let information = this.state.response && this.state.response['information'] ? this.state.response['information'] : null
            let status = this.state.response && this.state.response['status'] ? this.state.response['status'] : null
            resetFilterGo();
            return (<NoDataFound hideImg={true} is500={is500} status={status} information={information} response={this.state.response}/>);
        }
        else if (typeof this.state.chart == 'object' && this.state.chart?.['information'] && this.state.chart?.['information'] == "No data Available for the requested parameters") {
            return (<NoDataFound data={this.state.chart?.['information']} />);
        }
        else if (this.props.itemDetails && typeof this.props.itemDetails.parameters !== 'object' && IsJsonString(this.props.itemDetails.parameters) == false) {
            return (<NoDataFound hideImg={true} is500={true} />);
        }
        else if (this.state.chart == null) {
            mainData = <span>
                {topFilterToInsert}
                <LoadingComponent messages={[
                    "Processing your data ...",
                    "Generating your chart ..."
                ]} />
            </span>;
            // classLoad = "loader-div";
        } else if (this.state.chart == 0) {
            if (this.state.metric == '' || !this.state.metric) {
                resetFilterGo();
                //bubble of 3d scatter error condition
                if (this.state.chartCat.toLowerCase() == 'bubble' || ((this.state.chartCat.split(' ')[0]).toLowerCase() == 'scatter' && (this.state.chartCat.split(' ')[1])))
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter for 3 metrics to plot the chart' />
                    </span>;
                else if (this.state.chartCat.split(' ')[0].toLowerCase() == 'scatter' || this.state.chartCat.split(' ')[0].toLowerCase() == 'treemap')
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter for 2 metrics to plot the chart' />
                    </span>;
                else if (this.state.chartCat.split(' ')[0].toLowerCase() == 'map')
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter with atleast 1 metrics and 1 property to plot the chart' />
                    </span>;
                else if (this.props.chartDispStyle == 'timeseries' && (this.props.compare == "true" || this.props.compare))
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter with only 1 metrics and only 1 or no property value to plot the chart' />
                    </span>;
                else if (this.props.chartDispStyle == 'nontimeseries' && (this.props.compare == "true" || this.props.compare))
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter with only 1 metric and dates should be within a year to plot the chart' />
                    </span>;
                else
                    mainData = <span>
                        {topFilterToInsert}
                        <NoDataFound data='Please set a filter with only 1 metric to plot the chart' />
                    </span>;
            }
            else
                mainData = <span>
                    {topFilterToInsert}
                    <NoDataFound />
                </span>;
        }
        else if (this.state.chart == '5') {
            var tempValues = <p style={{
                fontSize: "20px"
            }}>Too big data to show
                in charts. Please try to narrow down data points by applying filters.<br />You can visualize high volume data in our data table.<br />
                <button
                    className="btn btn-contrast"
                    onClick={this
                        .props
                        .drillHandle
                        .bind(this, null, 'Table', 'errorHandle', null)}
                    style={{
                        marginTop: "10px"
                    }}>Go to Table</button>
            </p>;
            mainData = <span>
                {topFilterToInsert}
                <NoDataFound data={tempValues} />
            </span>;
        } else if (this.state.chart == -1) {
            mainData = <span>
                {topFilterToInsert}
                <NoDataFound data='Selected metric is not applicable for this chart. Please try with other metric.' />
            </span>;
        } else {
            if ((this.state.chartCat.toLowerCase() == 'line' || this.state.chartCat.toLowerCase() == 'line1') && this.state.period == 'day') {
                var handleClickLineEvent = this.handleClickLine;
            } else
                var handleClickLineEvent = null;
            var showSummary = this.state.summary;
            var temp_analysis = typeof this.props.analysis === "boolean" ? this.props.analysis.toString() : this.props.analysis;
            showSummary = (temp_analysis && (temp_analysis).split(',')[0] == 'radius') ? false : showSummary;
            if (showSummary) {
                summary = this.getSummaryContent(this.state.summary, this.state.startDateDisp, this.state.endDateDisp, 0);
                summaryDescription = this.getSummaryContent(this.state.summary, this.state.startDateDisp, this.state.endDateDisp, 1);
            } else {
                var summary = '';
                var summaryDescription = "";
            }
            var detail1 = null;
            var detail2 = [];
            var detail2_text = '';
            var dashboardDateInfo = null
            const parsedData = JSON.parse(this.props?.dataSet?.userDBSetting?.[0]?.information || '{}');
            const isFilterNew = parsedData?.filterInformation ? parsedData?.filterInformation : "0";

            if (this.props.breakupText) {
                let breakupList = this.props.breakUp.split(',');

                detail2.push(<span>Filtered by {isFilterNew == '0' ?
                    breakupList.map((item, index) => {
                        const [brand] = item.split(";");
                        return <span class="badge badge-light tx-13 mg-l-5" >{brand}</span>;
                    })
                    : this.props.breakupText}</span>);
                detail2_text += "Filtered by " + this.props.breakupText;
                detail2.push(<br />);
                detail2_text += "<br>";
            }
            if (this.props.includeText) {
                let includeList = this?.props?.include?.split(',');

                detail2.push(<span>Included: {isFilterNew == '0' ?
                    includeList.map((item, index) => {
                        const [brand] = item.split(";"); 
                        return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                    })
                    : this.props.includeText}</span>);
                detail2_text += "Included: " + this.props.includeText;
                detail2.push(<br />);
                detail2_text += "<br>";
            }
            if (this.props.excludeText) {
                let excludeList = this?.props?.exclude?.split(',');

                detail2.push(<span>Excluded: {isFilterNew == '0' ?
                    excludeList.map((item, index) => {
                        const [brand] = item.split(";"); 
                        return <span class="badge badge-light tx-13 mg-2" >{brand}</span>;
                    })
                    : this.props.excludeText}</span>);
                detail2_text += "Excluded: " + this.props.excludeText;
                detail2.push(<br />);
                detail2_text += "<br>";
            }
            var detail_analysis = "";
            if (this.props.metricText && this.props.propertyText) {
                var property = this.props.category;
                var propertyCount = property ? (property.split(',')).length : 0;
                var preposition = 'by';
                if (propertyCount == 1 && property.split(';')[1]) {
                    preposition = property.split(';')[1] == 'overall' ? 'at' : 'for';
                }
                detail1 = this.props.metricText + " " + preposition + " " + this.props.propertyText;
            }
            // if (this.state.breakupText)
            //     detail2 = "Filtered by "+this.state.breakupText;
            if (this.props.analysis === "radius" || this.props.analysis === "radius,quadrant")
                detail_analysis = <div className="col-md-12">{"Vicinity for " + this.props.allData.state.SelectedBreakUpDisp[this.props.allData.state.SelectedBreakUpDisp.length - 1].label + " with " + JSON.parse(this.props.clusterCount).radius + " KM"}</div>;
            if (this.props.startDate && this.props.endDate && (this.props.index == 1 || this.props.calendarStatus === true)) {
                if (granularity == "month")
                    var formatDateFunction = "MMMM, YYYY";//formatting the date time in description area
                else var formatDateFunction = "MMMM DD, YYYY";//formatting the date time in description area
                var detail3 = dashboardDateInfo = "Selected Date: " + moment(this.props.startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.props.endDate, 'YYYY-MM-DD').format(formatDateFunction);
                if(this.props?.metric?.includes('cagr')||this.props?.selectedMetric?.includes('cagr')){
                var cagrDate =  "CAGR Calculation Date: " + moment(this.state.chart.parameter_cache.date.startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state.chart.parameter_cache.date.endDate, 'YYYY-MM-DD').format(formatDateFunction);
                }
                if(this.state.chart?.parameter_cache?.prevDate?.startDate){
                var previousPeriodDate =  "Compared Date: " + moment(this.state.chart?.parameter_cache?.prevDate?.startDate, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state.chart?.parameter_cache?.prevDate?.endDate, 'YYYY-MM-DD').format(formatDateFunction);
                }
                

                var detail4 = null;
                if ((this.props.compare === "true" || this.props.compare === true) && this.state.compare_dates) {
                    detail4 = "Previous Date: " + moment(this.state.compare_dates.startDate2, 'YYYY-MM-DD').format(formatDateFunction) + " to " + moment(this.state.compare_dates.endDate2, 'YYYY-MM-DD').format(formatDateFunction);
                }
            }
            else {
                var detail3 = null;
                var detail4 = null;
            }
            if (this.props.question) {
                var SuggestedQuestion = <div
                    className="col-md-12">
                    <span>
                        <strong>Suggested Question :
                        </strong>
                        {" " + suggestedQuestion + " "}
                        <a
                            href={"/dashboard/alfred/query?query=" + suggestedQuestion + "&redirect=1"}
                            target="_blank">
                            Click here</a>
                    </span>
                </div>;
            } else
                var SuggestedQuestion = null;
            if (this.state.chart.growth) {
                var endIndex = Object.keys(this.state.chart.growth).length;
                var growthDataValues = this.state.chart.growth;
                var growthData = (this.state.chart.growth).map(function (innerData, index) {
                    var metricToPrint = refineData(innerData['description'], metricGlobal, metricFunction).label;
                    if (innerData['growth'] == 'N.A.') {
                        return innerData['growth'];
                    }
                    else if (index == endIndex - 1 && index != 0)
                        return " and " + metricToPrint + " is " + delimitNumbersIndianFormat(innerData['growth']) + " %"
                    else if (index)
                        return ", " + metricToPrint + " is " + delimitNumbersIndianFormat(innerData['growth']) + " %"
                    else return metricToPrint + " is " + delimitNumbersIndianFormat(innerData['growth']) + " %"
                })
            } else {
                var growthData = null;
            }

            if (SuggestedQuestion) {
                SuggestedQuestion = <li className="important item ui-sortable-handle" >
                    <label className="check pull-left todo" >
                        <div className="col-md-11 chartsInfo" >{SuggestedQuestion}</div>
                        <div className="col-md-1 pull-right" id='description1'>
                            <a title='Dislike' onClick={this.openComment.bind(this, 'disLike')} ><i className='glyphicon glyphicon-thumbs-down downVote' data-toggle="modal" id='description1Dislike' ></i></a>
                            <a title='Like' onClick={this.openComment.bind(this, 'like')}><i className='glyphicon glyphicon-thumbs-up upVote' id='description1Like'></i></a>
                        </div>
                    </label>
                </li>;
            }
            var globalFilter_details = null
            if (this.props.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter!="true") {
                globalFilter_details =  getGlobalFilterDetails(this.props.globalFilters)
            }
            


            if (detail4) {
                var final_details_hover = cagrDate + "<br>" + previousPeriodDate + "<br>" + detail3 + "<br>" + detail4 + "<br>" + detail1 + "<br>" + detail2_text;
                var final_details = (
                    <span
                        className={`tx-13 ${isFilterNew == '0' && this.props.globalFilters && this.props.globalFilters.length > 0 ? "" : "link-03"}`}
                        style={{ fontWeight: isFilterNew == '0' ? "bold" : "" }}
                    >
                        {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? cagrDate : null}
                        {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? <br /> : null}
                        
                        {detail3}
                        <br />
                        {previousPeriodDate?previousPeriodDate:null}
                        {previousPeriodDate ? <br />
                            : null}
                        {detail4}
                        <br />
                        {detail1}
                        <br />
                        {detail2}
                        {isFilterNew == "0" && this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? (
                            <>
                                Global Filter:
                                {this.props.globalFilters.map((innerdata) => (
                                    <span className="badge badge-info tx-13 mg-2" style={{ backgroundColor: "#ADD8E6", color: "black" }}>
                                        {innerdata.label}
                                    </span>
                                ))}
                            </>
                        ) : (
                            this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? globalFilter_details : null
                        )}
                    </span>
                );

            }
            else {
                var final_details_hover =   detail3 + "<br>" + detail1 + "<br>" + detail2;
                var final_details = (
                    <span
                        className={`tx-13 ${isFilterNew == '0' && this.props.globalFilters && this.props.globalFilters.length > 0 ? "" : "link-03"}`}
                        style={{ fontWeight: isFilterNew == '0' ? "bold" : "" }}
                    >
                        {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? cagrDate : null}
                        {this.props?.metric?.includes('cagr') || this.props?.selectedMetric?.includes('cagr') ? <br /> : null}
                        {previousPeriodDate}
                        {previousPeriodDate ? <br />
                            : null}
                        {detail3}
                        <br />
                        {detail1}
                        <br />
                        {detail2}
                        {isFilterNew == "0" && this.props.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? (
                            <>
                                Global Filter: 
                                {this.props.globalFilters.map((innerdata) => (
                                    <span className="badge badge-info tx-13 mg-2" style={{ backgroundColor: "#ADD8E6", color: "black" }}>
                                        {innerdata.label}
                                    </span>
                                ))}
                            </>
                        ) : (
                            this.props?.globalFilters && this.props.globalFilters.length > 0 && this.props.removeGlobalFilter != "true" ? globalFilter_details : null
                        )}
                    </span>
                );
            }
            if(dashboardDateInfo) {
                dashboardDateInfo = <span className='tx-13 link-03'>{dashboardDateInfo}</span>;
            }

            var final_metric = this.state.metric ? this.state.metric : this.state.selectedMetric;
            if (this.props.compare == true || this.props.compare == 'true') {
                var final_metric_array = [];
                final_metric.split(",").map(function (innerData, index) {
                    var temp = refineData(innerData, metricGlobal, metricFunction);
                    if (temp.previousValue == "1")
                        final_metric_array.push(temp.value);
                    final_metric_array.push(temp.value);
                });
                final_metric = final_metric_array.join();
            }            
            // var chartCat = this.props.chartDisp.toLowerCase() == "xrange" || this.props.chartDisp.toLowerCase() == "solidgauge" ? this.props.chartDisp : this.state.chartCat;
            var chartCat = ["xrange","solidgauge","waterfall","treemap"].indexOf(this.props.chartDisp.toLowerCase())>-1 ? this.props.chartDisp : this.state.chartCat;
            // chartCat = chartCat === 'Treemap' ? 'Bar' : chartCat;          
            
            let selectedMetricColumnlineSpecialCase = checkIfColumnlineSpecialCase(this.props.category, this.state.metric, this.state.chartType, this.props.chartDisp.toLowerCase(), Math.ceil(this.state?.chart?.data?.series?.length/2))
            selectedMetricColumnlineSpecialCase = selectedMetricColumnlineSpecialCase['status'] ? selectedMetricColumnlineSpecialCase['metric'] : selectedMetricColumnlineSpecialCase['status']
            
            let period = this.state.period ? this.state.period : this.state.chartType
            let pinboardComponentData = {
                'selectedMetricDisp': this.props.selectedMetricDisp,
                'period': period,
                'property': this.props.propertyDisp,
                'propertyDisp': this.props.propertyDisp,
                'breakup': this.props.breakUp,
                'SelectedBreakUpDisp': this.props.SelectedBreakUpDisp,
                'selectedMetric': this.props.metric,
                'include': this.props.include,
                'includeDisp': this.props.excludeDisp,
                'exclude': this.props.exclude,
                'excludeDisp': this.props.excludeDisp,
                'startDate': this.props.startDate,
                'endDate': this.props.endDate,
                'periodComparison': this.props.periodComparison,
                'dashboardConfig': this.props.dashboard_config,
                'chartType': this.props.chartType,
                'metricRange': this.props.metricRange
            }
            mainData = <>
                {summary}
                {topFilterToInsert}
                <ChartComponent
                    dataLabelConfig={this.props.dataLabelConfig}
                    yAxis={this.props.yAxis}
                    dataset={this.props.dataSet}
                    authData={this.props.authData}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}

                    title={this.props.chartTitle}
                    data={this.state.chart}
                    selectedMetric_new={final_metric}
                    selectedMetric={this.state.metric}
                    selectedMetricColumnlineSpecialCase={selectedMetricColumnlineSpecialCase}
                    contextMenu={1}
                    chartCat={chartCat}
                    chartDisp={this.props.chartDisp}
                    period={period}
                    index={this.props.index}
                    mainMetric={this.props.mainMetric ? this.props.mainMetric : metricGlobal}
                    stack={Stack}
                    timeHandle={this.props.timeHandle}
                    drillHandle={this.props.drillHandle}
                    insightHandle={this.props.insightHandle}
                    downloadFunction={this.props.downloadChart}
                    analysis={temp_analysis}
                    clusterCount={this.props.clusterCount}
                    category={this.props.category}
                    breakUp={this.props.breakUp}
                    include={this.props.include}
                    exclude={this.props.exclude}
                    detail1={detail1}
                    detail2={detail1}
                    mapType={this.props.mapType}
                    regressionLine={this.props.regressionLine}
                    property={this.props.propertyDisp}
                    isSegmentSelected={this.props.isSegmentSelected}
                    is3D={this.props.chartCat.split(' ')[1] == "3D" ? true : false}
                    selectedMetricDisp={this.props.selectedMetricDisp}
                    compare={this.props.compare}
                    dataMover={this.props.dataMover}
                    compareRank={this.props.compareRank}
                    final_details={final_details}
                    final_details_hover={final_details_hover}
                    dashboard_config={this.props.dashboard_config}
                    dashboard={this.props.dashboard}
                    ExportComponentVar={this.props.ExportComponentVar}
                    waterfallPointWidth={true}
                    dashboardDateInfo={dashboardDateInfo}
                    report_type={this.props.report_type}
                    trend_hover_information={this.props.trend_hover_information}
                />
            </>
        }
        return (
            <div>{mainData}</div>
        )
    }
}

export default Chart;

function checkVintageMetric(metric) {
    var useSummary = true;
    if (metric) {
        metric = decodeURIComponent(metric);
        metric = metric.split(',');
        metric.map(function (met) {
            met = met.split(';')[0];
            metricGlobal.map(function (val) {
                if (val.value == met && val.isDerived == 3) {
                    useSummary = false;
                    return;
                }
            });
        });
    }
    return useSummary;
}